import { ICONS, ASSETS } from "./assets";

export const EVENT = {
  name: "Balita Lili Tata Run 2026",
  short: "BLTR 2026",
  tagline: "Family Fun Run & Market",
  dateLabel: "16 Agustus 2026",
  dateISO: "2026-08-16",
  venue: "Batavia PIK",
  gatesOpen: "06:00 WIB",
  raceStart: "07:00 WIB",
  racepack: "14–15 Agustus 2026",
  contactEmail: "hello@balitarun.id",
  contactPhone: "+62 812-0000-0000",
};

export const TICKET_PACKAGE = {
  id: "parent-kiddo",
  name: "Parent + Kiddo Package",
  price: 599000,
  priceLabel: "IDR 599.000",
  perLabel: "/ 2 Pax",
  benefits: [
    "Masuk untuk 1 Orang Tua + 1 Anak",
    "Ikut Fun Run",
    "Akses Family Market",
    "Akses booking aktivitas terpilih",
    "Akses Meet & Greet*",
    "Racepack eksklusif",
    "Eligible Lucky Draw",
    "Best Dresscode Competition",
    "Akses seluruh pengalaman event",
  ],
};

// category values: meet-greet | kids | entertainment | competition | playground | market | run | treat
export const ACTIVITIES = [
  {
    id: "meet-greet",
    slug: "meet-greet",
    name: "Meet & Greet",
    category: "meet-greet",
    icon: ICONS.micTicket,
    image: "https://images.unsplash.com/photo-1596464716127-f2a82984de30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Ketemu langsung karakter Baba, Lili & Tata!",
    description:
      "Sapa langsung sahabat baru kamu — Baba si monyet, Lili si burung, dan Tata si gajah! Sesi foto bersama & pelukan hangat untuk si kecil.",
    bookingRequired: true,
    ageRecommendation: "Semua umur",
    location: "Main Stage Area",
    duration: "20 menit",
    rules: ["Datang 5 menit sebelum sesi", "1 tiket = 1 anak + 1 pendamping", "Dilarang membawa makanan ke area panggung"],
    slots: [
      { id: "mg-1", start: "09:00", end: "09:20", capacity: 20 },
      { id: "mg-2", start: "09:30", end: "09:50", capacity: 20 },
      { id: "mg-3", start: "10:00", end: "10:20", capacity: 20 },
      { id: "mg-4", start: "10:30", end: "10:50", capacity: 20 },
    ],
  },
  {
    id: "face-painting",
    slug: "face-painting",
    name: "Face Painting",
    category: "kids",
    icon: ICONS.palette,
    image: "https://images.unsplash.com/photo-1533326564427-3480e88bba6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Wajah ceria penuh warna untuk si kecil.",
    description:
      "Seniman face painting kami akan menyulap wajah anak jadi karakter favorit — kupu-kupu, superhero, atau si Baba Lili Tata!",
    bookingRequired: true,
    ageRecommendation: "3–12 tahun",
    location: "Kids Corner Tent",
    duration: "15 menit",
    rules: ["Gunakan cat aman non-toxic", "Beri tahu petugas jika anak punya alergi kulit"],
    slots: [
      { id: "fp-1", start: "10:00", end: "10:15", capacity: 12 },
      { id: "fp-2", start: "10:30", end: "10:45", capacity: 12 },
      { id: "fp-3", start: "11:00", end: "11:15", capacity: 12 },
      { id: "fp-4", start: "11:30", end: "11:45", capacity: 12 },
    ],
  },
  {
    id: "kids-competition",
    slug: "kids-competition",
    name: "Kids Competition",
    category: "competition",
    icon: ICONS.trophy,
    image: "https://images.unsplash.com/photo-1526634332515-d56c5fd16991?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Lomba seru berhadiah untuk anak-anak.",
    description:
      "Balap karung, tarik tambang mini, dan lomba estafet keluarga! Menangkan hadiah spesial dari BLTR 2026.",
    bookingRequired: true,
    ageRecommendation: "4–10 tahun",
    location: "Fun Field",
    duration: "30 menit",
    rules: ["Wajib pakai sepatu olahraga", "Didampingi 1 orang tua", "Ikuti arahan panitia"],
    slots: [
      { id: "kc-1", start: "13:00", end: "13:30", capacity: 16 },
      { id: "kc-2", start: "14:00", end: "14:30", capacity: 16 },
    ],
  },
  {
    id: "live-show",
    slug: "live-show",
    name: "Live Show",
    category: "entertainment",
    icon: ICONS.micTicket,
    image: "https://images.unsplash.com/photo-1508997449629-303059a039c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Panggung hiburan keluarga sepanjang hari.",
    description:
      "Nyanyi & menari bareng di panggung utama! Pertunjukan seru untuk seluruh keluarga. Tidak perlu reservasi — datang saja!",
    bookingRequired: false,
    ageRecommendation: "Semua umur",
    location: "Main Stage",
    duration: "Sepanjang acara",
    rules: [],
    slots: [],
  },
  {
    id: "playground",
    slug: "playground-experience",
    name: "Playground Experience",
    category: "playground",
    icon: ICONS.gift,
    image: "https://images.unsplash.com/photo-1560421683-6856ea585c78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Area bermain aman & seru untuk si kecil.",
    description:
      "Perosotan, kolam bola, dan wahana lembut untuk anak. Bebas main sepuasnya sepanjang acara.",
    bookingRequired: false,
    ageRecommendation: "1–8 tahun",
    location: "Play Zone",
    duration: "Bebas",
    rules: [],
    slots: [],
  },
  {
    id: "cotton-candy",
    slug: "cotton-candy",
    name: "Cotton Candy",
    category: "treat",
    icon: ICONS.gift,
    image: "https://images.unsplash.com/photo-1600359746315-119f1360d663?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Gula kapas manis gratis untuk peserta.",
    description: "Nikmati gula kapas warna-warni gratis. Tinggal tunjukkan tiket kamu di stall Cotton Candy!",
    bookingRequired: false,
    ageRecommendation: "Semua umur",
    location: "Treat Corner",
    duration: "Bebas",
    rules: [],
    slots: [],
  },
  {
    id: "balloon-station",
    slug: "balloon-station",
    name: "Balloon Station",
    category: "kids",
    icon: ICONS.gift,
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Balon lucu & giveaway untuk anak-anak.",
    description: "Ambil balon warna-warni dan ikutan balloon art. Gratis untuk semua peserta BLTR 2026!",
    bookingRequired: false,
    ageRecommendation: "Semua umur",
    location: "Balloon Corner",
    duration: "Bebas",
    rules: [],
    slots: [],
  },
  {
    id: "family-market",
    slug: "family-market",
    name: "Family Market",
    category: "market",
    icon: ICONS.tickets,
    image: "https://images.unsplash.com/photo-1533900298318-6b8da08a523e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Brand keluarga, makanan & pengalaman.",
    description: "Jelajahi puluhan brand keluarga, jajanan enak, dan aktivitas belanja seru. Akses termasuk dalam tiket.",
    bookingRequired: false,
    ageRecommendation: "Semua umur",
    location: "Market Village",
    duration: "Sepanjang acara",
    rules: [],
    slots: [],
  },
];

export const ACTIVITY_CATEGORIES = [
  { value: "all", label: "Semua" },
  { value: "available", label: "Available" },
  { value: "meet-greet", label: "Meet & Greet" },
  { value: "kids", label: "Kids Activities" },
  { value: "entertainment", label: "Entertainment" },
  { value: "competition", label: "Competition" },
  { value: "playground", label: "Playground" },
];

export const HOW_IT_WORKS = [
  { step: 1, title: "Beli Tiket", desc: "Pilih paket Parent + Kiddo kamu.", icon: ICONS.tickets },
  { step: 2, title: "Terima Kode Tiket", desc: "Setelah bayar, kamu dapat kode tiket unik.", icon: ICONS.signboard },
  { step: 3, title: "Booking Aktivitas", desc: "Pakai kode tiket untuk reservasi aktivitas.", icon: ICONS.finishFlag },
];

export const EXPERIENCES = [
  { name: "Family Fun Run", icon: ICONS.stopwatch },
  { name: "Family Market", icon: ICONS.tickets },
  { name: "Meet & Greet", icon: ICONS.micTicket },
  { name: "Face Painting", icon: ICONS.palette },
  { name: "Live Show", icon: ICONS.micTicket },
  { name: "Playground", icon: ICONS.gift },
  { name: "Kids Competition", icon: ICONS.trophy },
  { name: "Balloon Station", icon: ICONS.gift },
];

export const FAQS = [
  { q: "Siapa saja yang bisa ikut BLTR 2026?", a: "Event ini terbuka untuk keluarga — orang tua bersama anak-anak. Satu tiket berlaku untuk 1 orang tua + 1 anak." },
  { q: "Apa saja yang termasuk dalam satu tiket?", a: "Fun Run, akses Family Market, booking aktivitas terpilih, racepack, Meet & Greet*, dan eligibility Lucky Draw." },
  { q: "Umur berapa yang bisa berpartisipasi?", a: "Semua umur boleh datang. Beberapa aktivitas punya rekomendasi umur tertentu yang tertera di detail aktivitas." },
  { q: "Bisakah saya membawa lebih dari satu anak?", a: "Bisa! Silakan beli paket tambahan sesuai jumlah anak yang ikut." },
  { q: "Bagaimana cara menerima tiket?", a: "Setelah pembayaran berhasil, kode tiket unik akan langsung ditampilkan dan (nantinya) dikirim ke email/WhatsApp kamu." },
  { q: "Di mana saya bisa menemukan kode tiket?", a: "Kode tiket muncul di halaman konfirmasi dan bisa dilihat kembali melalui menu My Booking." },
  { q: "Bagaimana cara booking aktivitas?", a: "Buka menu Activities atau My Booking, masukkan kode tiket, lalu pilih aktivitas dan slot waktu yang tersedia." },
  { q: "Apakah slot aktivitas terbatas?", a: "Ya, aktivitas reservasi memiliki kapasitas per slot. Segera booking agar tidak kehabisan tempat." },
  { q: "Apa yang terjadi jika hujan?", a: "Sebagian besar aktivitas berada di area tertutup. Info lebih lanjut akan diumumkan mendekati hari-H. (placeholder)" },
  { q: "Apakah tiket bisa di-refund?", a: "Kebijakan refund akan diumumkan resmi. (placeholder — dapat diedit dari admin)" },
];

export const SPONSORS = [
  { category: "Venue Partner", names: ["BATAVIA PIK"] },
  { category: "Presented By", names: ["Pik Pik"] },
  { category: "Organized By", names: ["JT Event"] },
  { category: "Official Ticketing Partner", names: ["Blibli"] },
  { category: "Supported By", names: ["Amantara", "Livin' by Mandiri"] },
  { category: "Official Jersey Partner", names: ["LARI"] },
  { category: "Documentation Platform", names: ["FOTOYU"] },
  { category: "Official Media Partners", names: ["Popmama", "Nakita", "HaiBunda", "theAsianparent", "Female Daily"] },
];

// ---- Sample seed data for admin (participants / tickets) ----
export const SEED_TICKETS = [
  {
    ticketCode: "BLTR26-AB12CD", orderNumber: "ORD-100234", buyerName: "Sari Wulandari", email: "sari@example.com",
    mobile: "+62 812-1111-2222", parentName: "Sari Wulandari", childName: "Kayla", childAge: 5, childGender: "Perempuan",
    emergencyContact: "Budi", emergencyPhone: "+62 813-0000-1111", paymentStatus: "Paid", ticketStatus: "Active",
    purchaseDate: "2026-06-02", bookings: [
      { ref: "BK-0001", activityId: "meet-greet", slotId: "mg-4", status: "Confirmed", checkIn: "Registered" },
      { ref: "BK-0002", activityId: "face-painting", slotId: "fp-3", status: "Confirmed", checkIn: "Checked In" },
    ],
  },
  {
    ticketCode: "BLTR26-EF34GH", orderNumber: "ORD-100235", buyerName: "Andi Pratama", email: "andi@example.com",
    mobile: "+62 812-3333-4444", parentName: "Andi Pratama", childName: "Rafi", childAge: 7, childGender: "Laki-laki",
    emergencyContact: "Rina", emergencyPhone: "+62 813-2222-3333", paymentStatus: "Paid", ticketStatus: "Active",
    purchaseDate: "2026-06-03", bookings: [
      { ref: "BK-0003", activityId: "meet-greet", slotId: "mg-1", status: "Confirmed", checkIn: "Registered" },
      { ref: "BK-0004", activityId: "kids-competition", slotId: "kc-1", status: "Confirmed", checkIn: "Registered" },
    ],
  },
  {
    ticketCode: "BLTR26-IJ56KL", orderNumber: "ORD-100236", buyerName: "Maya Santoso", email: "maya@example.com",
    mobile: "+62 812-5555-6666", parentName: "Maya Santoso", childName: "Nadia", childAge: 4, childGender: "Perempuan",
    emergencyContact: "Doni", emergencyPhone: "+62 813-4444-5555", paymentStatus: "Paid", ticketStatus: "Active",
    purchaseDate: "2026-06-05", bookings: [
      { ref: "BK-0005", activityId: "face-painting", slotId: "fp-1", status: "Confirmed", checkIn: "No Show" },
    ],
  },
  {
    ticketCode: "BLTR26-MN78OP", orderNumber: "ORD-100237", buyerName: "Rudi Hartono", email: "rudi@example.com",
    mobile: "+62 812-7777-8888", parentName: "Rudi Hartono", childName: "Bima", childAge: 8, childGender: "Laki-laki",
    emergencyContact: "Wati", emergencyPhone: "+62 813-6666-7777", paymentStatus: "Pending", ticketStatus: "Active",
    purchaseDate: "2026-06-06", bookings: [],
  },
  {
    ticketCode: "BLTR26-QR90ST", orderNumber: "ORD-100238", buyerName: "Dewi Lestari", email: "dewi@example.com",
    mobile: "+62 812-9999-0000", parentName: "Dewi Lestari", childName: "Alya", childAge: 6, childGender: "Perempuan",
    emergencyContact: "Hadi", emergencyPhone: "+62 813-8888-9999", paymentStatus: "Paid", ticketStatus: "Active",
    purchaseDate: "2026-06-07", bookings: [
      { ref: "BK-0006", activityId: "meet-greet", slotId: "mg-2", status: "Confirmed", checkIn: "Checked In" },
      { ref: "BK-0007", activityId: "kids-competition", slotId: "kc-2", status: "Confirmed", checkIn: "Registered" },
    ],
  },
];

export const TICKET_SALES_TREND = [
  { day: "1 Jun", tickets: 12 }, { day: "2 Jun", tickets: 28 }, { day: "3 Jun", tickets: 41 },
  { day: "4 Jun", tickets: 35 }, { day: "5 Jun", tickets: 58 }, { day: "6 Jun", tickets: 73 },
  { day: "7 Jun", tickets: 90 },
];

export const ADMIN_USER = { email: "admin@balitarun.id", password: "bltr2026", name: "Event Admin", role: "Super Admin" };
